<div class="ibox">
  <iboxtools *ngIf="contrato != null"
             [Title]=""
             [isHistory]=true
             [DateInit]="contrato?.desde"
             [DateEnd]="contrato?.hasta"
             [PeriodList]="contratosList"
             [IsEditing]="isEditing"
             (PeriodChange)="OnPeriodChange($event)"
             (NewChange)="OnNewChange($event)"
             (EditChange)="OnEditChange($event)"
             (SaveChange)="OnSaveChange($event)"
             (CutChange)="OnCutChange($event)"
             (DeleteChange)="OnDeleteChange($event)"
             (CancelChange)="OnCancelChange($event)"
             [Permiso]="permisoEdicion">
  </iboxtools>
  <div class="ibox-content" *ngIf="contrato != null">
    <mat-error *ngIf="contratosInvalida" class="contratosInvalida">{{MensajeError}}</mat-error>
    <form [formGroup]="form">
      <div class="row" hidden="true">
        <input formControlName="id" name="id" type="text" class="form-control" />
        <input formControlName="personal" name="personal" type="text" class="form-control" />
      </div>
      <div class="row panel panel-warning" *ngIf="!disabledEditing">
        <div class="col-lg">
          <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
          <div class="col-lg-8">
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="desde" required dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
            <div *ngIf="registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">La Fecha es requerida</div>
            <mat-error *ngIf="registerFormControl.desde.errors?.desdeAnterior && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
            </mat-error>
            <mat-error *ngIf="registerFormControl.desde.errors?.anteriorRetroactividad && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al límite de retroactividad {{gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
            </mat-error>
          </div>
        </div>
        <div class="col-lg">
          <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
          <div class="col-lg-8">
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="hasta" required dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
            <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched || submitted)" class="text-danger">La Fecha es requerida</div>
            <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched || submitted)">
              La Fecha no puede ser menor que la Fecha Desde
            </mat-error>
          </div>
        </div>
      </div>
      <div>
      </div>
      <div class="row">
        <div class="col-lg">
          <label class=" col-form-label font-bold">Clase de contrato</label>
          <comboTools [list]=clasesContratosList
                      [formParent]="form"
                      selected='claseContrato'
                      [isEditing]=disabledEditing
                      filter="descripcion"
                      (SelectedChange)="onChangeContrato($event)"
                      ph='Clase de Contrato'></comboTools>
          <div *ngIf="registerFormControl.claseContrato.invalid && submitted" class="text-danger">
            <div *ngIf="registerFormControl.claseContrato.errors.required">La clase de contrato es requerido</div>
          </div>
        </div>
        <div class="col-lg">
          <label class=" col-form-label font-bold" for="fechafinC">Fecha fin de contrato</label>
          <p-calendar appendTo="body" selectOtherMonths="true" formControlName="fechafinC" required dateFormat="dd/mm/yy" inputId="fechafinC" ngDefaultControl></p-calendar>
          <div *ngIf="registerFormControl.fechafinC.errors?.required && (registerFormControl.fechafinC?.dirty || registerFormControl.fechafinC?.touched || submitted)" class="text-danger">La Fecha es requerida</div>
          <mat-error  class="text-danger" *ngIf="registerFormControl.fechafinC.errors?.fecCompHasta && (registerFormControl.fechafinC?.dirty || registerFormControl.fechafinC?.touched || submitted)">
            La Fecha no puede ser mayor que la Fecha Hasta
          </mat-error>
        </div>
      </div>
      <div class="row">
        <div class="col-lg">
          <label class=" col-form-label font-bold" for="fechaFinPrueba">Fecha fin de período de prueba</label>
          <p-calendar appendTo="body" selectOtherMonths="true" formControlName="fechaFinPrueba" required dateFormat="dd/mm/yy" inputId="fechaFinPrueba" ngDefaultControl></p-calendar>
          <div *ngIf="registerFormControl.fechaFinPrueba.errors?.required && (registerFormControl.fechaFinPrueba?.dirty || registerFormControl.fechaFinPrueba?.touched || submitted)" class="text-danger">La Fecha es requerida</div>
          <mat-error  class="text-danger" *ngIf="registerFormControl.fechaFinPrueba.errors?.fecCompHasta && (registerFormControl.fechaFinPrueba?.dirty || registerFormControl.fechaFinPrueba?.touched || submitted)">
            La Fecha no puede ser mayor que la Fecha Hasta
          </mat-error>
        </div>
        <div class="col-lg">
          <label class=" col-form-label font-bold">Período de Prueba</label>
          <input formControlName="periodoPrueba" name ="periodoPrueba" type="number" class="form-control" maxlength="50" />
          <div *ngIf="(registerFormControl.periodoPrueba.touched || submitted) && registerFormControl.periodoPrueba.errors?.required" class="text-danger">Campo obligatorio</div>
        </div>  
      </div>
      <div class="row">
        <div class="col-lg">
          <label class=" col-form-label font-bold">Horas mensuales</label>
          <input formControlName="horasMensuales" name ="horasMensuales" type="number" class="form-control" maxlength="50" />
          <div *ngIf="(registerFormControl.horasMensuales.touched || submitted) && registerFormControl.horasMensuales.errors?.required" class="text-danger">Campo obligatorio</div>
        </div>  
        <div class="col-lg">
          <label class=" col-form-label font-bold">Horas jornada laboral</label>
          <input formControlName="horasJornadaLaboral" name ="horasJornadaLaboral" type="number" class="form-control" maxlength="50" />
          <div *ngIf="(registerFormControl.horasJornadaLaboral.touched || submitted) && registerFormControl.horasJornadaLaboral.errors?.required" class="text-danger">Campo obligatorio</div>
        </div>  
      </div>
    </form>
  </div>
</div>

<div class="ibox-content m-b-sm border-bottom" *ngIf="contrato == null && cargaCompleta">
  <button type="button" pButton pRipple pTooltip="Agregar" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='add()'></button>
  <div class="p-xs">
    <div class="float-left m-r-md">
      <i class="fa fa-globe text-navy mid-icon"></i>
    </div>
    <h2>Empleado sin Contratos</h2>
    <span>El empleado no tiene Contratos.</span>
  </div>
</div>


